//components
import { FlexColumnCentered } from '@/components/Grid/Flex';
import {
  Section,
  QuoteContainer,
  Quote,
  QuoteSource,
} from './QuoteSection.style';

export const QuoteSection = () => (
  <Section>
    <QuoteContainer>
      <FlexColumnCentered>
        <Quote>
          “We believe that by combining cutting-edge technology with the right
          industry partnerships, we can make the lives of shippers and carriers
          just a little bit easier and help them move more with less. And while
          the company has grown leaps and bounds since we started as a scrappy
          startup just five short years ago, one thing has remained constant:
          our greatest strength is our people.”
        </Quote>
        <QuoteSource>
          <b>
            Ricardo Salgado and
            <br /> Felipe Capella,&nbsp;
          </b>
          <br />
          Loadsmart founders
        </QuoteSource>
      </FlexColumnCentered>
    </QuoteContainer>
  </Section>
);
